<template>
  <div class="my-item">
    <div class="photo-tabs">
      <Row>
        <Col span="20">
          <div style="width: 950px;">
            <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
              <TabPane label="Not grouped" name="1"></TabPane> 
              <template v-if="albumData">
                <TabPane
                  :label="item.name"
                  :name="(index + 2 + '')"
                  v-for="(item, index) in albumData.items"
                  :key="'album' + index"
                ></TabPane>
              </template>
            </Tabs>
          </div>
        </Col>
        <Col span="4">
          <div class="photo-tool">
            <!-- <span class="photo-tool-btn">展开更多</span> -->
            <span class="photo-tool-btn s-blue">
              <Poptip
                placement="bottom-end"
                width="300"
                class="add-group-box"
                v-model="addVisible"
                @on-cancel="groupName=''"
              >
                <span>Create a group</span>
                <div slot="content" class="add-group">
                  <div class="title">Create a group</div>
                  <div class="content">
                    <Input
                      v-model="groupName"
                      :maxlength="5"
                      placeholder="Please enter the group name"
                      style="width: 100%"
                    />
                  </div>
                  <div class="bottom">
                    <Button type="primary" :loading="addLoading" @click="handleAddAlbum">Confirm</Button>
                    <Button @click="addVisible=false">Cancel</Button>
                  </div>
                </div>
              </Poptip>
            </span>
          </div>
        </Col>
      </Row>
      <router-view v-if="String(showTabs) === '1'" ref="photoMaterialAll"></router-view>
      <!-- <router-view v-if="String(showTabs) === '2'" ref="photoMaterialLoose"></router-view> -->
      <router-view v-if="Number(showTabs) >= 2" ref="photoMaterialGroup"></router-view>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "photo-material",
  data() {
    return {
      showTabs: "1",
      albumData: null,
      addLoading: false, // 添加 add
      addVisible: false,
      groupName: "" // 分组名称
    };
  },
  watch: {
    $route(to, from) {  
      this.init();
    }
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    }),
    option() {
      return {
        CompId: this.company.id,
        pageSize: 1000
      };
    },
    query() {
      return this.$router.history.current.query;
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getAlbum: "albumModule/getAlbum",
      addAlbum: "albumModule/addAlbum"
    }),
    async init() {
      this.albumData = await this.getAlbum(this.option); 
      this.changeTab();
    },
    switchMaterial(name) {
      if (name === "1") {
        this.switchName = "1";
        this.init();
      } else if (name === "2") {
        this.switchName = "2";
        this.init();
      }
    },
    changeTab() {
      const path = this.$router.history.current.path;
      const query = this.$router.history.current.query;
      if (path && path.indexOf("/exhibitionEn/index/material/photo/all") !== -1) {
        this.showTabs = "1";
      } else if (
        path &&
        path.indexOf("/exhibitionEn/index/material/photo/loose") !== -1
      ) {
        // this.showTabs = "2";
      } else if (
        path &&
        path.indexOf("/exhibitionEn/index/material/photo/group") !== -1
      ) {
        this.showTabs = "2";
        this.albumData.items.forEach((c, idx) => {
          if (query.id && query.id === c.id) {
            this.showTabs = idx + 2 + "";
          }
        });
      }
    },
    switchBrand(name) {
      if (name === "1") {
        this.$router.push("/exhibitionEn/index/material/photo/all");
      } else if (Number(name) >= 2) {
        if (this.$refs.photoMaterialGroup) {
          this.$refs.photoMaterialGroup.hideAdd();
        }
        let cur = this.albumData.items[name - 2];
        this.$router.push(
          `/exhibitionEn/index/material/photo/group?id=${cur.id}`
        );
      }
    },
    async handleAddAlbum() {
      if (!this.groupName) return;
      this.addLoading = true;
      setTimeout(() => {
        this.addLoading = false;
      }, 5000);
      // 添加图集
      const req = {
        CompId: this.company.id,
        Name: this.groupName,
        Cover: "",
        ItemName: this.groupName,
        StyleId: "1",
        Introduction: this.groupName,
        Tag: this.groupName
      }; 
      this.addAlbum(req)
        .then(v => {
          this.init();
          this.$Message.success("successful");
          this.groupName = "";
          this.addLoading = false;
          this.addVisible = false;
        })
        .catch(e => {
          this.$Message.error("fail,please try again");
          this.loading = false;
        });
    },
    sendAdd() { 
      if (this.showTabs === "1") {
        if (this.$refs.photoMaterialAll) {
          this.$refs.photoMaterialAll.showAdd();
        }
      }
      // if (this.showTabs === "2") {
      //   if (this.$refs.photoMaterialLoose) {
      //     this.$refs.photoMaterialLoose.showAdd();
      //   }
      // }
      if (Number(this.showTabs) >= 2) {
        if (this.$refs.photoMaterialGroup) {
          this.$refs.photoMaterialGroup.showAdd();
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.photo {
  &-tool {
    background: #fff;
    display: flex;
    height: 43px;
    align-items: center;
    justify-content: center;
    &-btn {
      flex: 1;
      text-align: center;
      cursor: pointer;
      &.s-blue {
        color: #1890ff;
      }
    }
  }
}
</style>
<style lang="scss">
.my-item {
  min-width: 1200px;
}
.photo-tabs {
  background: #fff;
  .ivu-tabs-bar {
    width: 950px;
    box-shadow: 0px 0px 7px 0px rgba(146, 160, 185, 0.2);
    &::before {
      box-shadow: none;
    }
  }
  .ivu-tabs-nav .ivu-tabs-tab {
    width: 105px;
    text-align: center;
  }
  .ivu-tabs-nav-scrollable {
    padding: 0px 22px 0 26px;
  }
}
.add-group-box {
  .ivu-poptip-body {
    padding: 0;
    margin: 0;
    width: 300px;
    height: 218px;
  }
  .add-group {
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(53, 153, 231, 0.2);
    text-align: left;
  }
  .title {
    padding: 20px 30px;
    font-size: 18px;
    color: #333;
    border-bottom: 1px solid #ddd;
  }
  .content {
    padding: 30px 16px;
  }
  .bottom {
    border-top: 1px solid #ddd;
    text-align: right;
    padding: 12px 30px;
    button {
      margin-left: 10px;
    }
  }
}
</style>
